(() => {
    document.querySelectorAll('.swiper').forEach((el) => {
        var loop = Boolean(el.dataset.loop) || false;
        var autoplay = parseInt(el.dataset.autoplay) * 1000 || 0;
        var slidesPerView = parseInt(el.dataset.slidesPerView) || 1;

        console.log(loop, 'loop');
        console.log(autoplay, 'autoplay');
        console.log(slidesPerView, 'slidesPerView');

        const swiper = new Swiper(el, {
            // Optional parameters
            spaceBetween: 0,
            slidesPerView: slidesPerView,
            effect: 'fade',
            fadeEffect: {
                crossFade: false
            },
            // direction: 'vertical',
            loop: loop,
            rewind: true,
            speed: 1000,
            autoplay: {
                delay: autoplay,
            },

            // If we need pagination
            pagination: {
                el: '.slider-pagination',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.slider-button--next',
                prevEl: '.slider-button--prev',
            },

            // And if we need scrollbar
            /*scrollbar: {
                el: '.swiper-scrollbar',
            },*/
        });
    });

})();
